document.addEventListener("DOMContentLoaded", () => {
  if (!customElements.get("ces-2026-calendar")) {
    class CES2026Calendar extends HTMLElement {
      constructor() {
        super();
        this.swiperContainer = $(this).find(".swiper-container");
        this.dates = $(this).find(".ces-2026-calendar-date");
        this.schedules = $(this).find(".ces-2026-calendar-schedule");
      }

      connectedCallback() {
        this.initSwiper();
        this.initDateCard();
        this.initMark();
      }

      initSwiper() {
        const self = this;
        if (this.swiperContainer.length !== 0) {
          this.swiperInstance = new Swiper(this.swiperContainer[0], {
            autoplay: {
              delay: 5000,
              disableOnInteraction: false,
            },
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
          });
        }
      }

      initDateCard() {
        this.setActiveDateCard($(this.dates[0]).data("date"));
        this.dates.each((index, el) => {
          $(el).on("click", () => {
            // if (!this.swiperInstance) return;
            // this.swiperInstance.slideTo(index);
            this.setActiveDateCard(index);
          });
        });
      }

      setActiveDateCard(index) {
        this.dates.each((_, el) => {
          const $el = $(el);
          if ($el.data("date") === index) {
            $el.addClass("active");
          } else {
            $el.removeClass("active");
          }
        });
        this.schedules.each((_, el) => {
          const $el = $(el);
          if ($el.data("date") === index) {
            $el.addClass("active");
          } else {
            $el.removeClass("active");
          }
        });
      }

      initMark() {
        const $mark1 = $(this).find(".ces-2026-calendar-mark-1").eq(0);

        $(this)
          .find(".has-mark-1")
          .each((_, el) => {
            $(el).append($mark1.clone().css("display", "block"));
          });

        const $mark2 = $(this).find(".ces-2026-calendar-mark-2").eq(0);

        $(this)
          .find(".has-mark-2")
          .each((_, el) => {
            $(el).append($mark2.clone().css("display", "block"));
          });
      }
    }
    customElements.define("ces-2026-calendar", CES2026Calendar);
  }
});
